module.exports = __webpack_public_path__ + "static/media/espaceG.ee846550.svg";